export const LONG_BREAK_COUNT = 3;